import { webClient } from "@shared/apis"

export default {
  validate: async (scheduleId: number) =>
    webClient.post<WownetValidInfo>(
      `${process.env.REACT_APP_API_URL}/wownet/validate`, { scheduleId }, {
        withCredentials: true
      }),
  getPartnerInfo: (analId: string, userid: string) =>
    webClient.get<PartnerInfo>("/wownet/user_addon", {
      params: { analId, userid },
    }),
  cancelAlarm: (analId: string, userid: string) =>
    webClient.post<PartnerInfo>("/wownet/cancel_alarm", {
      analId,
      userid,
    }),
  getPartnerEvent: (analId: string) =>
    webClient.get<WownetEvent>("/wownet/partner_event", { params: { analId } }),
}

export interface PartnerInfo {
  isAlarmOn: boolean | string
}

interface WownetValidInfo {
  validState: string
  isValid: boolean
}

export interface WownetEvent {
  eventSn: string | null
  eventTitle: string | null
  imageUrl: string | null
  linkUrl: string | null
}
